webpackJsonp([124591039235529],{

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    @media (min-width: 1516px) {\n        position: absolute;\n    }\n"], ["\n    @media (min-width: 1516px) {\n        position: absolute;\n    }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: 1.2em;\n    display: inline-block;\n    padding: ", "em 0;\n    color: ", ";\n    cursor: pointer;\n    @media (min-width: 1516px) {\n        padding: 0;\n    }\n"], ["\n    font-size: 1.2em;\n    display: inline-block;\n    padding: ", "em 0;\n    color: ", ";\n    cursor: pointer;\n    @media (min-width: 1516px) {\n        padding: 0;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledRow = (0, _styledComponents2.default)(_rlaComponents.Row)(_templateObject);
	
	var Button = _styledComponents2.default.a.attrs({
	    role: "button"
	})(_templateObject2, _theme.spacing.padding, _theme.colors.lightGray);
	
	var BackButton = function BackButton(_ref) {
	    var goBack = _ref.goBack;
	    return _react2.default.createElement(
	        StyledRow,
	        { expanded: true },
	        _react2.default.createElement(
	            _rlaComponents.Column,
	            null,
	            _react2.default.createElement(
	                Button,
	                { onClick: goBack },
	                console.log(goBack),
	                _react2.default.createElement(_reactFontawesome2.default, { icon: "arrow-left" })
	            )
	        )
	    );
	};
	
	exports.default = BackButton;
	module.exports = exports["default"];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 40vw;\n    max-height: 450px;\n    min-height: 180px;\n    background-size: cover;\n    background-position: center;\n    background-image: url('", "');\n    margin-bottom: 2.8em;\n    position: relative;\n"], ["\n    width: 100%;\n    height: 40vw;\n    max-height: 450px;\n    min-height: 180px;\n    background-size: cover;\n    background-position: center;\n    background-image: url('", "');\n    margin-bottom: 2.8em;\n    position: relative;\n"]);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.src;
	});
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background: rgba(0, 0, 0, 0.8);\n    padding: ", "em;\n"], ["\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background: rgba(0, 0, 0, 0.8);\n    padding: ", "em;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    color: ", ";\n    background: ", ";\n"], ["\n    display: inline-block;\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    color: ", ";\n    background: ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    font-weight: 900;\n    text-align: center;\n    color: ", ";\n    font-family: inherit;\n    text-transform: none;\n    @media (min-width: ", "px) {\n        font-size: 2.3rem;\n    }\n"], ["\n    margin: 0;\n    font-weight: 900;\n    text-align: center;\n    color: ", ";\n    font-family: inherit;\n    text-transform: none;\n    @media (min-width: ", "px) {\n        font-size: 2.3rem;\n    }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    @media (min-width: ", "px) {\n        width: 80%;\n    }\n"], ["\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    @media (min-width: ", "px) {\n        width: 80%;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Overlay = _styledComponents2.default.div(_templateObject, _theme.spacing.padding);
	
	var Category = _styledComponents2.default.h5(_templateObject2, function (props) {
	    return props.theme.lightColor;
	}, function (props) {
	    return props.theme.accent;
	});
	
	var Title = _styledComponents2.default.h2(_templateObject3, function (props) {
	    return props.theme.lightColor;
	}, _theme.breakpoints.xlarge);
	
	var TitleContainer = _styledComponents2.default.div(_templateObject4, _theme.breakpoints.xlarge);
	
	var JobHeader = function JobHeader(_ref) {
	    var title = _ref.title,
	        hero = _ref.hero,
	        area = _ref.area;
	
	    return _react2.default.createElement(
	        Overlay,
	        null,
	        _react2.default.createElement(
	            Category,
	            null,
	            area
	        ),
	        _react2.default.createElement(
	            TitleContainer,
	            null,
	            _react2.default.createElement(
	                Title,
	                null,
	                title
	            )
	        )
	    );
	};
	
	exports.default = JobHeader;
	module.exports = exports["default"];

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.JobTemplate = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding: ", "em ", "em 0;\n    background: #ebebeb;\n    margin-bottom: ", "em;\n    p {\n        margin: 0 0 0.8em;\n    }\n"], ["\n    padding: ", "em ", "em 0;\n    background: #ebebeb;\n    margin-bottom: ", "em;\n    p {\n        margin: 0 0 0.8em;\n    }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    margin-top: 2rem;\n"], ["\n    margin-top: 2rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _helpers = __webpack_require__(12);
	
	var _image = __webpack_require__(44);
	
	var _theme = __webpack_require__(6);
	
	var _Content = __webpack_require__(35);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _JobHeader = __webpack_require__(1130);
	
	var _JobHeader2 = _interopRequireDefault(_JobHeader);
	
	var _BackButton = __webpack_require__(145);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Hero = __webpack_require__(146);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SummaryContainer = _styledComponents2.default.section(_templateObject, _theme.spacing.padding, _theme.spacing.padding, _theme.spacing.margin);
	var JobContainer = _styledComponents2.default.section(_templateObject2);
	
	var JobTemplate = exports.JobTemplate = function JobTemplate(props) {
	    var content = props.content,
	        contentComponent = props.contentComponent,
	        title = props.title,
	        area = props.area,
	        helmet = props.helmet,
	        description = props.description,
	        hero = props.hero,
	        level = props.level,
	        location = props.location,
	        salary = props.salary,
	        hours = props.hours,
	        benefits = props.benefits,
	        closing = props.closing,
	        transition = props.transition,
	        history = props.history;
	
	    var PostContent = contentComponent || _Content2.default;
	
	    return _react2.default.createElement(
	        _PageDetailContainer2.default,
	        { style: transition && transition.style },
	        helmet || "",
	        _react2.default.createElement(_BackButton2.default, { goBack: history.goBack }),
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                null,
	                _react2.default.createElement(
	                    _Hero2.default,
	                    { src: hero && (0, _image.getOriginalImageSrc)(hero) },
	                    _react2.default.createElement(_JobHeader2.default, { area: area, title: title, hero: hero })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            JobContainer,
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                description && [_react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 7, className: "cms-content" },
	                    _react2.default.createElement(PostContent, { content: description })
	                ), _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 1 },
	                    "\xA0"
	                )],
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: description && 4 },
	                    _react2.default.createElement(
	                        SummaryContainer,
	                        null,
	                        level && _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Level:" },
	                            level
	                        ),
	                        _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Salary:" },
	                            salary
	                        ),
	                        _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Hours:" },
	                            hours
	                        ),
	                        _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Location:" },
	                            location
	                        ),
	                        _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Benefits:" },
	                            benefits.map(function (benefit, index) {
	                                return _react2.default.createElement(
	                                    "p",
	                                    { key: index },
	                                    benefit
	                                );
	                            })
	                        ),
	                        closing && _react2.default.createElement(
	                            SummaryItem,
	                            { label: "Closing:" },
	                            (0, _helpers.dateFormat)(closing)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryContainer,
	                        null,
	                        _react2.default.createElement(
	                            "h4",
	                            null,
	                            "TO APPLY"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { style: { paddingBottom: "1rem" } },
	                            "Please send your Cover Letter, CV and other supporting documents to",
	                            " ",
	                            _react2.default.createElement(
	                                "a",
	                                { href: "mailto:careers@rla.co.uk" },
	                                "careers@rla.co.uk"
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var SummaryItem = function SummaryItem(_ref) {
	    var label = _ref.label,
	        children = _ref.children;
	    return _react2.default.createElement(
	        _rlaComponents.Row,
	        null,
	        _react2.default.createElement(
	            _rlaComponents.Column,
	            { large: 6, xlarge: 4, collapse: true },
	            _react2.default.createElement(
	                "h5",
	                null,
	                label
	            )
	        ),
	        _react2.default.createElement(
	            _rlaComponents.Column,
	            { large: 6, xlarge: 8, collapse: true },
	            children
	        )
	    );
	};
	
	exports.default = function (_ref2) {
	    var history = _ref2.history,
	        transition = _ref2.transition,
	        data = _ref2.data;
	
	    //console.log(data);
	    var job = data.markdownRemark;
	
	    return _react2.default.createElement(JobTemplate, {
	        helmet: _react2.default.createElement(_reactHelmet2.default, { title: "Careers | " + job.frontmatter.title }),
	        title: job.frontmatter.title,
	        area: job.frontmatter.area,
	        content: job.html,
	        description: job.frontmatter.description,
	        hero: job.frontmatter.hero,
	        level: job.frontmatter.level,
	        location: job.frontmatter.location,
	        salary: job.frontmatter.salary,
	        hours: job.frontmatter.hours,
	        benefits: job.frontmatter.benefits,
	        closing: job.frontmatter.closing,
	        transition: transition,
	        history: history
	    });
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-job-js-0e2d9a94c336c13d7139.js